var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomAdult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0.75 3.75 16.5 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4687",
    "data-name": "Rectangle 4687",
    width: 18,
    height: 18,
    transform: "translate(138 1534)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_145",
    "data-name": "Mask Group 145",
    transform: "translate(-138 -1534)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e822662f626e872b7bdbe2a27af64301",
    transform: "translate(138 1534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38436",
    "data-name": "Path 38436",
    d: "M0,0H18V18H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38437",
    "data-name": "Path 38437",
    d: "M11.875,7.625a2.25,2.25,0,1,0-2.25-2.25A2.241,2.241,0,0,0,11.875,7.625Zm-6,0a2.25,2.25,0,1,0-2.25-2.25A2.241,2.241,0,0,0,5.875,7.625Zm0,1.5c-1.747,0-5.25.878-5.25,2.625v1.125a.752.752,0,0,0,.75.75h9a.752.752,0,0,0,.75-.75V11.75C11.125,10,7.623,9.125,5.875,9.125Zm6,0c-.217,0-.465.015-.727.038.015.008.022.023.03.03a3.12,3.12,0,0,1,1.448,2.558v1.125a2.253,2.253,0,0,1-.135.75h3.885a.752.752,0,0,0,.75-.75V11.75C17.125,10,13.623,9.125,11.875,9.125Z",
    transform: "translate(0.125 0.625)",
    fill: "#4258bf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomAdult);
export default __webpack_public_path__ + "static/media/room-adult.22c255be931618d1e58fad9848630bde.svg";
export { ForwardRef as ReactComponent };